const AUTH_EVENT_LABELS: Record<string, string> = {
  'login.success': 'Connexion réussie',
  'login.failed': 'Échec de connexion',
  'login.locked': 'Compte verrouillé',
  'lockout.triggered': 'Verrouillage activé',
  'register.success': 'Inscription réussie',
  'register.failed': 'Échec d’inscription',
  logout: 'Déconnexion',
  'logout.all': 'Déconnexion partout',
  'device.new': 'Nouvel appareil',
  'device.removed': 'Appareil retiré',
  'password.changed': 'Mot de passe modifié',
  'refresh.success': 'Session renouvelée',
  'refresh.replay_detected': 'Rejeu de jeton détecté',
  'refresh.expired': 'Session expirée',
  'user.role_changed': 'Rôle modifié',
};

export function authEventTypeLabel(eventType: string): string {
  return AUTH_EVENT_LABELS[eventType] ?? eventType;
}
